export const checksums = {
  "content": "v3.5.0--Pvrc0GQdIfRzWHghMIe-YuA_ZkgC6bAZWKy0nuvvdZ8"
}
export const checksumsStructure = {
  "content": "oJ6vLrAdfh-vn4lQmQ0DcDji5amhPvWLlgxxAy2svxY"
}

export const tables = {
  "content": "_content_content",
  "info": "_content_info"
}

export default {
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "subtitle": "string",
      "atlasDescription": "string",
      "label": "string",
      "wiki": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}